<template>
	<AssemblyLayout :assembly="assembly" :subtitle="trans('assemblies.elections.event-hosts.title')">
		<template #actions>
			<select v-model="eventType">
				<option v-for="event in EventType" :value="event">{{ trans(`events.${event}.title`) }}</option>
			</select>
			<PrimaryButton :color="Color.Green" @click.stop="store">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Empty v-if="elections.length === 0"/>
		<CardGrid v-else>
			<Card v-for="election in elections" :key="`event-host-election-${election.id}`" :title="trans(`events.${election.event_type}.title`)">
				<template #badges>
					<Badge v-if="election.open" :color="Color.Green" active>{{ trans('general.open') }}</Badge>
					<Badge v-else :color="Color.Red">{{ trans('general.closed') }}</Badge>
				</template>
				<LabeledObject>
					<template #label>{{ trans('assemblies.seats') }}</template>
					<p>{{ election.limit }}</p>
				</LabeledObject>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.assemblies.elections.event-hosts.show', {assembly: assembly.id, election: election.id})">
						<i class="fa-solid fa-edit mr-2"/>
						{{ trans('general.edit') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AssemblyLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/UI/Empty.vue'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {EventType} from '@/Types/Enums/EventType'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import AssemblyLayout from '@/Layouts/AssemblyLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type EventHostElection} from '@/Types/Elections/Assemblies/EventHostElection'

const props = defineProps<{
	assembly:Assembly,
	selectedTab:string,
	elections:Array<EventHostElection>,
}>()

const working:Ref<boolean> = ref(false)
const eventType:Ref<string> = ref(EventType.CAEII)
const assembly:Ref<Assembly> = ref(props.assembly)
const elections:Ref<Array<EventHostElection>> = ref(props.elections)

function store():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		axios.post(route('association.assemblies.elections.event-hosts.store', assembly.value.id), {
			event_type: eventType.value,
		}).then(({data}:{data:EventHostElection}) => {
			showSuccess(trans('general.inserted'))
			elections.value.unshift(data)
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>